// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/data-extraction-poll/data-extraction-poll.component.scss
// module id = 577
// module chunks = 0